export enum ESignupFormSteps {
  verificationOption = 'verificationOption',
  password = 'password',
  confirmation = 'confirmation',
  personalDetails = 'personalDetails',
}
